export class ProjectOptions {
    constructor() {
        this.source = "";
        this.wordToArticle = true;
    }
}

export class Project {
    constructor(theUserName, theProjectName) {
        this._id = undefined;
        this.type = "project";
        this.date = new Date();

        this.name = theProjectName;
        this.userName = theUserName;

        this.options = new ProjectOptions();
    }
}
export class w2dPdf {
    constructor(theName, theDocLink, theProjectId, theAreaName) {
        this._id = undefined;
        this.type = "pdf";
        this.date = new Date();

        this.parentproject = theProjectId;
        this.area = theAreaName;

        this.name = theName;
        this.doclink = theDocLink; // Path to the pdf file
        this.file = ""; // Path to an additional file that describes the pdf file
        this.imglink = ""; // Path to the preview
        this.body = "";
    }
}

export class w2dImage {
    constructor(theName, theLink, theProjectId, theAreaName, dest) {
        this._id = undefined;
        this.type = "img";
        this.date = new Date();

        this.parentproject = theProjectId;
        this.area = theAreaName;

        this.name = theName;
        this.imglink = theLink; // Path to the image binary
        this.file = ""; // Path to an additional file that describes the image
        this.body = "";
        this.dest = dest;
    }
}

export class w2dArticle {
    constructor(theName, theProjectId, theAreaName) {
        this._id = undefined;
        this.type = "url";
        this.date = new Date();

        this.parentproject = theProjectId;
        this.area = theAreaName;

        this.name = theName;
        this.headline = "";
        this.lead = "";
        this.body = "";
        this.imglink = "";
        this.url = "";
        this.file = "";
    }
}

export class w2dAny {
    constructor(theName, theDocLink, theProjectId, theAreaName) {
        this._id = undefined;
        this.type = "any";
        this.date = new Date();

        this.parentproject = theProjectId;
        this.area = theAreaName;

        this.name = theName;
        this.doclink = theDocLink; // Path to the binary file
        this.file = ""; // Path to an additional file that describes the  file
        this.imglink = ""; // Path to the preview
        this.body = "";
    }
}
